<template>
  <div class="stock-control" v-if="false">
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">Stock Control</h3>
          <h3 class="title-page mb-0 ps-3">
            BRANCH - {{ items && items.length > 0 ? items[0].branch_name : "" }}
          </h3>
        </div>
      </div>
      <div
        class="col-lg-4 col-md-5 col-5 d-flex justify-content-end"
        v-if="isMobile == false"
      >
        <material-button
          @click="
            token
              ? handleEnableOrDisableAll(false)
              : check_passcode_is_empty == 0 || isAuthorized == true
              ? handleEnableOrDisableAll(false)
              : checkPasscodeStock(1)
          "
          class="mx-2 btn-background btn-sm"
        >
          Disable
        </material-button>
        <material-button
          @click="
            token
              ? handleEnableOrDisableAll(true)
              : check_passcode_is_empty == 0 || isAuthorized == true
              ? handleEnableOrDisableAll(true)
              : checkPasscodeStock(2)
          "
          class="mx-2 btn-background btn-sm"
        >
          Enable
        </material-button>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="notifications">
            <material-alert
              v-if="error"
              color="danger"
              icon="ni ni-like-2 ni-lg"
              dismissible
            >
              {{ error }}
            </material-alert>
          </div>
          <div class="col-lg-12 col-md-12 col-12 mx-auto" v-if="isLoadData">
            <div class="row my-3 d-flex align-items-left">
              <div class="row">
                <div
                  class="col-lg-8 col-12"
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="width: 30%; min-width: 300px;">
                    <input
                      class="nosubmit"
                      type="search"
                      id="keyword_search"
                      v-model="searchKeyword"
                      extraClass
                      name="keyword_search"
                      placeholder="Search item name or item code..."
                      @input="onChangesearchKeyword"
                    />
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="d-flex align-items-center waiting-time">
                    <Multiselect
                      v-model="waitingTimeSelect"
                      :options="waitingTime"
                      placeholder="Select Waiting Time"
                      :canClear="false"
                      @change="changeWaitingTime"
                    />
                    <material-button class="ms-3 btn btn-sm btn-background" style="min-width: 160px;" @click="stopOrdering()"
                      >{{ branch.stop_ordering ? 'Start Ordering' : 'Stop Ordering' }}</material-button
                    >
                  </div>
                </div>
                </div>
              <div class="row">
                <div class="col-lg-3 col-6 d-flex mt-3">
                  <div 
                    class="cursor-pointer"
                    :class="{'title-page fs-16 text-decoration-underline': itemType === 1}"
                    @click="changeItemType(1)"
                  >Main</div>
                  <div class="mx-3">|</div>
                  <div
                    class="cursor-pointer"
                    :class="{'title-page fs-16 text-decoration-underline': itemType === 2}"
                    @click="changeItemType(2)"
                  >Modifier</div>
                </div>
                <div class="col-lg-3 col-6 d-flex mt-3">
                  <div
                    class="cursor-pointer"
                    :class="{'title-page fs-16 text-decoration-underline': fieldDisplay === 1}"
                    @click="changeFieldDisplay(1)"
                  >Name</div>
                  <div class="mx-3">|</div>
                  <div
                    class="cursor-pointer"
                    :class="{'title-page fs-16 text-decoration-underline': fieldDisplay === 2}"
                    @click="changeFieldDisplay(2)"
                  >Description</div>
                </div>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table
                        class="table align-items-center mb-0"
                        style="color: #222"
                      >
                        <thead>
                          <tr>
                            <th
                              class="text-center font-weight-bolder w-5"
                              v-if="isMobile == false"
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :checked="isAllSelected"
                                  @change="selectAll"
                                />
                              </div>
                            </th>
                            <th
                              class="font-weight-bolder w-20 position-relative"
                              @click="handleChangeSortColumn(1)"
                            >
                              <span
                                :class="[
                                  'wrapper-sortby pointer',
                                  ESortDirectionSelect.idx == 1
                                    ? ESortDirectionSelect.direction ===
                                      ESortDirection.Desc
                                      ? 'sort-desc'
                                      : 'sort-asc'
                                    : '',
                                ]"
                                >{{ $t("Item No") }}</span
                              >
                            </th>
                            <th
                              class="font-weight-bolder w-30 position-relative"
                              @click="handleChangeSortColumn(fieldDisplay === 1 ? 2 : 3)"
                            >
                              <span
                                :class="[
                                  'wrapper-sortby pointer',
                                  [2,3].includes(ESortDirectionSelect.idx)
                                    ? ESortDirectionSelect.direction ===
                                      ESortDirection.Desc
                                      ? 'sort-desc'
                                      : 'sort-asc'
                                    : '',
                                ]"
                                >{{ fieldDisplay === 1 ? $t("Item Name") : $t("Description") }}</span
                              >
                            </th>
                            <th class="font-weight-bolder w-20">
                              {{ $t("On Off") }}
                            </th>
                            <th class="font-weight-bolder w-25">
                              {{ $t("Count Down") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="items.length">
                          <tr v-for="(value, key) in items" :key="key">
                            <td
                              class="text-center text-xss w-5"
                              v-if="isMobile == false"
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :value="value.id"
                                  v-model="selectedItems"
                                />
                              </div>
                            </td>
                            <td 
                              class="text-xss w-20 fs-16 min-w-75px"
                              style="max-width: 20%; width: 200px; white-space: normal; word-break: break-word;"
                              >
                              {{ value.item_no }}
                            </td>
                            <td
                              class="text-xss w-30 fs-16 min-w-200px"
                              style="max-width: 50%; width: 300px; white-space: normal; word-break: break-word;"
                            >
                              {{ fieldDisplay === 1 ? value.item_name : value.description }}
                            </td>
                            <td class="text-xss w-20 min-w-75px">
                              <div
                                :class="{
                                  active:
                                    value.is_not_available == 0 ? true : false,
                                }"
                                class="toggle_container"
                              >
                                <MaterialToggleButton
                                  labelEnableText=""
                                  labelDisableText=""
                                  :id="value.id + 'event_handle_available'"
                                  v-on:change="
                                    token
                                      ? triggerEventAvailable($event, value)
                                      : check_passcode_is_empty == 0 ||
                                        isAuthorized == true
                                      ? triggerEventAvailable($event, value)
                                      : checkPasscodeTriggerItem($event, value)
                                  "
                                  class="mb-0"
                                />
                              </div>
                            </td>
                            <td class="text-xss w-25 min-w-200px">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                "
                                v-if="!value.stock_enable_balance"
                              >
                                <div class="me-1">
                                  {{ value.stock_balance }}
                                </div>
                                <MaterialToggleButton
                                  labelEnableText=""
                                  labelDisableText=""
                                  :id="value.id + 'event_handle_stock_on_off'"
                                  v-on:change="
                                    token
                                      ? triggerEventStockOnOff($event, value)
                                      : check_passcode_is_empty == 0 ||
                                        isAuthorized == true
                                      ? triggerEventStockOnOff($event, value)
                                      : checkPasscodeTriggerStockOnOff(
                                          $event,
                                          value
                                        )
                                  "
                                  class="mb-0"
                                  :disabled="
                                    value.is_not_available != 0 ? true : false
                                  "
                                />
                              </div>
                              <div
                                style="display: flex; align-items: center"
                                v-else
                              >
                                <material-input
                                  v-model="value.stock_balance"
                                  type="text"
                                  class="text-stock-balance"
                                />
                                <i
                                  @click="
                                    token
                                      ? onChangeStock(value)
                                      : check_passcode_is_empty == 0 ||
                                        isAuthorized == true
                                      ? onChangeStock(value)
                                      : checkPasscodeChangeStockBalance(value)
                                  "
                                  style="cursor: pointer"
                                  class="material-icons-round opacity-10 fs-5"
                                  >save</i
                                >
                                <div
                                  :class="{
                                    active:
                                      value.stock_enable_balance == 1
                                        ? true
                                        : false,
                                  }"
                                  class="toggle_container"
                                >
                                  <MaterialToggleButton
                                    labelEnableText=""
                                    labelDisableText=""
                                    :id="value.id + 'event_handle_stock_on_off'"
                                    v-on:change="
                                      token
                                        ? triggerEventStockOnOff($event, value)
                                        : check_passcode_is_empty == 0 ||
                                          isAuthorized == true
                                        ? triggerEventStockOnOff($event, value)
                                        : checkPasscodeTriggerStockOnOff(
                                            $event,
                                            value
                                          )
                                    "
                                    class="mb-0"
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="10" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>

      <div>
        <button
          style="display: none"
          type="button"
          id="action-group-stock"
          data-bs-toggle="modal"
          data-bs-target="#modalCheckStockPasscodePage"
        ></button>
        <div
          class="modal fade"
          id="modalCheckStockPasscodePage"
          tabindex="-1"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">PASSCODE REQUIRED</h5>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label class="control-label" style="margin-left: 0px"
                    ><strong> Please enter passcode to continue.</strong></label
                  >
                  <div>
                    <material-input
                      v-model="passcodeStockValue"
                      extraClass="ml-5"
                      placeholder="Enter passcode"
                    />
                    <span class="is-invalid" v-if="passcodeIncorrect">{{
                      passcodeIncorrect
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- Modal content-->
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-success btn-background btn-sm"
                  @click="checkPasscode"
                >
                  Ok
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-close-modal btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <material-loading :active="loaderActive" />
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import TokenService from "../../services/token.service";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";
import ItemService from "../../services/product/item.service";
import MaterialInput from "@/components/MaterialInput.vue";
import $ from "jquery";
import SettingStoreService from "../../services/settingStore.service";
import Multiselect from "@vueform/multiselect";

export default {
  name: "stock",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    MaterialToggleButton,
    MaterialInput,
    Multiselect
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      items: [],
      searchKeyword: "",
      isLoadData: false,
      merchantCode: "",
      token: TokenService.getLocalAccessToken(),
      nodeEnv: process.env.VUE_APP_NODE_ENV,
      searchTimerId: null,
      selectedItems: [],
      enterStockTimerId: null,
      passcodeStockValue: "",
      type: "",
      passcodeIncorrect: "",
      eventChangeStockBalance: null,
      itemChangeStockBalance: null,
      isMobile: false,
      check_passcode_is_empty: 0,
      isAuthorized: false,
      timeoutHandle: null,
      ESortDirectionSelect: {
        idx: null,
        direction: null
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      itemType: 1, // 1: Main, 2: Modifier
      fieldDisplay: 1, // 1: Name, 2: Description
      waitingTime: [],
      waitingTimeSelect: 0,
      branch: {},
      merchantId: this.$route.params.merchant_id,
      branchCode: this.$route.params.branch_code,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.checkWindowSize();
    window.addEventListener("resize", this.checkWindowSize);
    const code = localStorage.getItem("MERCHANT_CODE", "");
    this.merchantCode = code ? `/${code}` : "";
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkWindowSize);
  },
  methods: {
    checkWindowSize() {
      if (window.innerWidth < 1200) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    changeItemType(type) {
      this.itemType = type;
      this.getList();
    },

    changeFieldDisplay(field) {
      this.fieldDisplay = field;
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList();
      }, 1000);
    },

    getList() {
      // this.isLoadData = false;
      // this.items = [];
      this.showLoader();
      var dataForm = {
        search_keyword: this.searchKeyword,
        merchantId: this.merchantId,
        branchCode: this.branchCode,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
        itemType: this.itemType
      };

      ItemService.getAllStockItems(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            // this.check_passcode_is_empty =
            //   response.data.data.check_passcode_is_empty;
            // this.items = response.data.data.items;
            // this.branch = response.data.data.branch;
            // this.waitingTime = response.data.data.waiting_time;
            // this.waitingTimeSelect = this.branch.waiting_time;
            // this.isLoadData = true;
            window.location.href = response.data.data.physical_branch_stock_link;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    handleChangeSortColumn(idx) {
      if (this.ESortDirectionSelect.idx && this.ESortDirectionSelect.idx == idx) {
        this.ESortDirectionSelect.direction = this.ESortDirectionSelect.direction === this.ESortDirection.Asc ? this.ESortDirection.Desc : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          direction: this.ESortDirection.Asc
        }
      }
      
      if (this.items.length) {
        this.getList();
      }
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    selectAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.items.map((item) => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    handleEnableOrDisableAll(is_disabled) {
      this.resetTimeout();
      if (this.selectedItems && this.selectedItems.length > 0) {
        // this.isLoadData = false;
        this.showLoader();
        var dataForm = {
          is_disabled: is_disabled,
          selectedItems: this.selectedItems,
          branchCode: this.branchCode,
          merchantId: this.merchantId,
        };
        ItemService.handleEnableOrDisableAvailableAll(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Updated successfully!";
              this.setTimeOutNotification();
              this.getList();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
          }
        );
        this.hideLoader();
      } else {
        this.snackbar = "danger";
        this.message = "You must select least 1 column to export file.";
        this.setTimeOutNotification();
      }
    },
    handleEnableOrDisable(item) {
      // this.isLoadData = false;
      this.showLoader();
      var dataForm = {
        id: item.id,
        value: item.is_not_available ? 0 : 1,
        branchCode: this.branchCode,
        merchantId: this.merchantId,
      };
      ItemService.handleEnableOrDisableAvailable(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Updated successfully!";
            this.setTimeOutNotification();
            this.getList();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          // this.eventChangeStockBalance = null;
          this.itemChangeStockBalance = null;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.hideLoader();
    },
    triggerEventAvailable(event, value) {
      this.resetTimeout();
      if (typeof event == "boolean") {
        this.handleEnableOrDisable(value);
      }
    },
    triggerEventStockOnOff(event, value) {
      this.resetTimeout();
      if (typeof event == "boolean") {
        this.handleStockOnOff(value);
      }
    },
    onChangeStock(item) {
      this.resetTimeout();
      clearTimeout(this.enterStockTimerId);
      this.enterStockTimerId = setTimeout(() => {
        // this.isLoadData = false;
        this.showLoader();
        var dataForm = {
          id: item.id,
          stock_balance: item.stock_balance,
          branchCode: this.branchCode,
          merchantId: this.merchantId,
        };
        ItemService.updateStockBalanceByItem(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Updated successfully!";
              this.setTimeOutNotification();
              this.getList();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.eventChangeStockBalance = null;
            this.itemChangeStockBalance = null;
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
          }
        );
        this.isLoadData = true;
        this.hideLoader();
      }, 1000);
    },
    checkPasscodeStock(type) {
      this.type = type;
      const editGroup = document.getElementById("action-group-stock");
      editGroup.click();
    },
    checkPasscodeChangeStockBalance(item) {
      this.itemChangeStockBalance = item;
      this.type = 3;
      const editGroup = document.getElementById("action-group-stock");
      editGroup.click();
    },
    checkPasscodeTriggerItem(event, item) {
      this.itemChangeStockBalance = item;
      this.type = 4;
      const editGroup = document.getElementById("action-group-stock");
      editGroup.click();
    },
    checkPasscodeTriggerStockOnOff(event, item) {
      this.itemChangeStockBalance = item;
      this.type = 5;
      const editGroup = document.getElementById("action-group-stock");
      editGroup.click();
    },
    checkPasscode() {
      this.passcodeIncorrect = "";
      // this.isLoadData = false;
      this.showLoader();
      var dataForm = {
        merchantId: this.merchantId,
        branchCode: this.branchCode,
        passcode: this.passcodeStockValue,
      };
      ItemService.checkPasscodeStockPage(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess && response.data.data) {
            this.isAuthorized = true;
            this.resetTimeout();
            this.passcodeIncorrect = "";
            if (this.type == 1) {
              this.type = "";
              this.passcodeStockValue = "";
              this.handleEnableOrDisableAll(false);
            } else if (this.type == 2) {
              this.type = "";
              this.passcodeStockValue = "";
              this.handleEnableOrDisableAll(true);
            } else if (this.type == 3) {
              this.type = "";
              this.passcodeStockValue = "";
              this.onChangeStock(this.itemChangeStockBalance);
            } else if (this.type == 4) {
              this.type = "";
              this.passcodeStockValue = "";
              this.handleEnableOrDisable(this.itemChangeStockBalance);
            } else if (this.type == 5) {
              this.type = "";
              this.passcodeStockValue = "";
              this.handleStockOnOff(this.itemChangeStockBalance);
            }
            $(".btn-close-modal").click();
          } else {
            this.passcodeIncorrect = "Passcode incorrect!";
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.isLoadData = true;
      this.hideLoader();
    },
    handleStockOnOff(item) {
      // this.isLoadData = false;
      this.showLoader();
      var dataForm = {
        id: item.id,
        value: item.stock_enable_balance ? 0 : 1,
        branchCode: this.branchCode,
        merchantId: this.merchantId,
      };
      ItemService.handleStockOnOff(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Updated successfully!";
            this.setTimeOutNotification();
            this.getList();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          // this.eventChangeStockBalance = null;
          this.itemChangeStockBalance = null;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.hideLoader();
    },
    changeWaitingTime(waitingTime) {
      if (this.branchCode) {
        this.showLoader();
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
          waiting_time: waitingTime
        };

        SettingStoreService.changeWaitingTime(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Change success";
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      }
    },
    stopOrdering() {
      if (!this.branch.stop_ordering) {
        if(!confirm("Confirm to stop the ordering for today?")){
          return;
        }
      }

      if (this.branchCode) {
        this.showLoader();
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
        };

        SettingStoreService.stopOrdering(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              if (this.branch.stop_ordering) {
                this.branch.stop_ordering = 0;
              } else {
                this.branch.stop_ordering = 1;
              }

              this.snackbar = "success";
              this.message = "Change success";
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      }
    },
    formatItemNo(item) {
      var itemNo = item.item_no;
      const maxLength = 5;
      if (itemNo.length > maxLength) {
        const regex = new RegExp(`.{1,${maxLength}}`, "g");
        return itemNo.match(regex).join("<br>") + ". " + item.item_name;
      } else {
        return itemNo + ". " + item.item_name;
      }
    },
    resetTimeout() {
      if (this.timeoutHandle) {
        clearTimeout(this.timeoutHandle);
      }
      this.timeoutHandle = setTimeout(
        this.removePasscodeWhenExpired,
        30 * 60 * 1000
      ); // 30 minutes
    },
    removePasscodeWhenExpired() {
      this.isAuthorized = false;
    },
  },
  computed: {
    isAllSelected: {
      get() {
        return (
          this.selectedItems && this.selectedItems.length === this.items.length
        );
      },
      set(value) {
        if (value) {
          this.selectedItems = this.items.map((item) => item.id);
        } else {
          this.selectedItems = [];
        }
      },
    },
  },
};
</script>
<style scoped>
.stock-control {
  color: #222 !important;
}

.text-title {
  color: #133067 !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.text-label {
  color: #5b848d !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.checkbox-auto-save label {
  padding-top: 11px !important;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 1px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.custom-name {
  word-break: break-all;
  max-width: 200px;
  white-space: normal;
}

.input-group
  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  text-align: center !important;
  margin-left: 0px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.wrapper-sortby::after {
    bottom: 6px;
    right: 20px;
}
.wrapper-sortby::before {
    bottom: 7px;
    right: 20px;
}

.fs-16 {
  font-size: 16px !important;
}

.min-w-75px {
  min-width: 75px !important;
}

.min-w-200px {
  min-width: 200px !important;
}

.toggle_container {
  display: flex;
  align-items: center;
}

.toggle__button {
  display: contents;
}

@media (max-width: 500px) {
  .min-w-75px {
    min-width: 75px !important;
    max-width: 75px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .min-w-200px {
    min-width: 175px !important;
    max-width: 175px !important;
    /* white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important; */
  }
} 
</style>
